import AuthCli from './AuthCli'

/**
 * JavaScript version of the Billable service API.
 */
export default class BillableCli {

  //
  // Path constants:
  //
  static get SERVICE_ROUTE() { return 'billable' }
  static get REALM_PATH() { return 'realms' }
  static get REALM_ID() { return 'realm' }
  static get BILLABLE_PATH() { return 'billables' }
  static get BILLABLE_ID() { return 'billableid' }
  static get PARENT_PATH() { return 'parents' }
  static get PARENT_ID() { return 'parentid' }
  static get PARENT_TOP() { return 'top' }
  static get SESSION_PATH() { return 'session' }

  // URL prefix for debugging environment vs behind reverse proxy environment.
  static get devPrefix() { return (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'http://localhost:6006/' : window.location.protocol + '//' + window.location.host + '/api/' }

  /**
   * Provides the information about the billable linked to a specified realm.
   * @param {string} realm Identifier of a realm as defined in auth service
   * @returns {BillableInfo} Null if not found (string billableId, string billableCode, string billableTitle, string description, string parentId, int children, bool usersEnabled, bool adminEnabled)
   */
  static async GetBillableByRealm(realm) {
    var verb = 'GET'
    var path = this.SERVICE_ROUTE + '/' + this.REALM_PATH + "/" + realm
    var body = null

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }

  /**
   * Provides the information about a billable given its unique identifier.
   * @returns {BillableInfo} Null if not found (string billableId, string billableCode, string billableTitle, string description, string parentId, int children, bool usersEnabled, bool adminEnabled)
   */
  static async GetBillableById(billableId) {
    var verb = 'GET'
    var path = this.SERVICE_ROUTE + '/' + this.BILLABLE_PATH + "/" + billableId
    var body = null

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }

  /**
  * Provides the general information about those billables directly falling
  * from the specified parent billable.
  * @param {string} parentId Pass PARENT_TOP constant value to ask for all top-level billables
  * @returns {BillableInfo} Null if not found (string billableId, string billableCode, string billableTitle, string description, string parentId, int children, bool usersEnabled, bool adminEnabled)
  */
  static async GetAllBillablesOf(parentId) {
    var verb = 'GET'
    var path = this.SERVICE_ROUTE + '/' + this.PARENT_PATH + "/" + parentId
    var body = null

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }

  /**
   * Provides the information about the billable at the top of the branch
   * of a given billable.
   + This method is to be called by services.
   * @param {*} billableId Internal identifier of the billable whose top billable is asking for
   * @returns Null if not found
   */
  static async GetTopBillableOf(billableId) {
    var verb = 'GET'
    var path = this.SERVICE_ROUTE + '/' + this.BILLABLE_PATH + "/" + billableId + "/" + this.PARENT_TOP
    var body = null

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }

  /**
   * Provides the information about the billable at the top of the branch
   * of the billable linked to a specified realm.
   * @param {string} realm Identifier of a realm as defined in auth service
   * @returns {BillableInfo} Null if not found (string billableId, string billableCode, string billableTitle, string description, string parentId, int children, bool usersEnabled, bool adminEnabled)
   */
  static async GetTopBillableByRealm(realm) {
    var verb = 'GET'
    var path = this.SERVICE_ROUTE + '/' + this.REALM_PATH + "/" + realm + "/" + this.PARENT_TOP
    var body = null

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }

  /**
   * Provides the information about the billable associated with the current authorization session.
   * @returns 
   */
  static async GetBillableOfSession() {
    var verb = 'GET'
    var path = this.SERVICE_ROUTE + '/' + this.BILLABLE_PATH + "/" + this.SESSION_PATH
    var body = null

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }

  /**
   * Registers a new billable into the platform or modifies its definition.
   * @param {Billable} billable Definition of the billable. If unique identifier is provided then the existing will be modified (string billableId, string billableCode, string billableTitle, string description, string parentId, bool usersEnabled, bool adminEnabled)
   * @returns {string} Unique identifier assigned to the billable
   */
  static async StoreBillable(billable) {
    var verb = 'PUT'
    var path = this.SERVICE_ROUTE
    var body = billable

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }
  
  /**
   * Removes an existing billable from the platform.
   * Any users in this billable will no longer be able to access.
   * @param {string} billableId Unique identifier of the billable to be removed
   */
  static async DeleteBillable(billableId) {
    var verb = 'DELETE'
    var path = this.SERVICE_ROUTE + '/' + billableId
    var body = null
    
    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }
}


// WEBPACK FOOTER //
// ./src/sdk/BillableCli.js